<template>
  <footer>
    <img class="divide_img" src="../assets/divide_img.png">
    <div class="divide"></div>
    <div class="footer_info">
      <div class="item">
        <div>
          <img src="../assets/printbelle_logo.png" alt="logo" style="height: 28px">
        </div>

        <div class="item_box">
          <div class="title">DIKE INTERNATIONAL CO LIMITED</div>
          <div class="des">Working hours: 9:00-18:00 (China)</div>
          <div class="des">Fulfillment Address: Printing Industry Park, Longyan<br>City, Fujian Province, China</div>
          <div class="des">Media Address: 10/F Easey Commercial Building 253-261<br>Hennessy Road Wanchai HK China</div>
          <div class="des">Email: support@printbelle.com</div>
          <div class="des">
            Social network:
            <a href="https://www.facebook.com/share/hEbhkZ3uadDQqFGg/" target="_blank">
              <img src="../assets/facebook.png" alt="logo" style="width: 23px;height: 23px;margin-left: 10px">
            </a>
            <a href="https://youtube.com/@printbelle?si=PDL-sO2SGepX2CNa" target="_blank">
              <img src="../assets/youtube.png" alt="logo" style="width: 23px;height: 23px;margin-left: 10px">
            </a>
            <a v-if="false">
              <img src="../assets/tiktok.png" alt="logo" style="width: 23px;height: 23px;margin-left: 10px">
            </a>
          </div>
        </div>
      </div>
      <div class="item_1" style="margin-left: 285px">
        <div class="title">About Us</div>
        <a @click="goto('About Us')">About Us</a>
        <a :href="skypeConfig">Contact Us</a>
        <a
          @click="gotoUrl('details/membership-introduction')">Membership Introduction</a>
        <a
          @click="gotoThisUrl('/legal/terms')">Terms & Conditions</a>
      </div>
      <div class="item_1" style="margin-left: 292px">
        <div class="title">Resources</div>
        <a
          @click="gotoUrl()">Help Center</a>
        <a
          @click="gotoUrl('list/faqs')">FAQ</a>
        <a
          @click="gotoUrl('details/how-to-creating-products-in-the-designer')">Mockup tutorial</a>
        <a
          @click="gotoUrl('details/how-can-i-fulfill-orders-with-printbelle')">Create Orders</a>

        <a href="https://documenter.getpostman.com/view/25923095/2s93RL1vvB" target="_blank">API Docs</a>
      </div>
    </div>
    <div class="divide"></div>
    <div class="printbelle">© 2016 - 2025 Printbelle. All rights reserved</div>
  </footer>
</template>
<script>

import {get} from '@/api'

export default {
  components: {},
  data () {
    return {
      showModal: false,
      skypeConfig: ''
    }
  },
  created () {
    this.getSkypeConfig()
  },
  methods: {
    hideModal () {
      this.showModal = false
    },
    getSkypeConfig () {
      get('/merchant/index/config/skype')
        .then(response => {
          this.skypeConfig = 'skype:' + response.data + '?chat'
        })
        .catch(error => {
          console.error(error)
        })

    },
    goto (name) {
      this.$router.push({name: name})
    },
    gotoUrl (url) {
      if (url) {
        window.open(process.env.VUE_APP_HELP_PC + url, '_blank')
      } else {
        window.open(process.env.VUE_APP_HELP_PC, '_blank')
      }
    },
    gotoThisUrl (url) {
      this.$router.push({path: url})
    },
  }
}
</script>
<style scoped lang="less">

footer {
  display: flex;
  flex-direction: column;
  height: 592px;
  background-image: url(../assets/footer_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .divide_img {
    width: 1500px;
    height: 37px;
    margin-left: 210px;
    margin-bottom: 37px;
    margin-top: 35px;
  }

  .footer_info {
    font-family: Roboto;
    display: flex;
    margin-top: 53px;
    margin-left: 210px;


    .item {
      display: flex;
      flex-direction: column;

      .item_box {
        margin-top: 26px;
        margin-bottom: 20px;

        .title {
          font-family: Roboto;
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 18px;
          color: #E0E0E0;
        }

        .des {
          font-family: Roboto;
          font-weight: 500;
          margin-bottom: 13px;
          font-size: 15px;
          color: #E0E0E0;
          line-height: 24px;
        }

      }
    }

    .item_1 {
      display: flex;
      flex-direction: column;
      margin-top: -4px;

      .title {
        font-weight: bold;
        font-size: 18px;
        color: #E0E0E0;
        margin-bottom: 25px;
      }

      a {
        font-weight: 400;
        font-size: 15px;
        color: #E0E0E0;
        line-height: 36px;
        transition: color 0.3s ease;
      }

      a:hover {
        color: #FFFFFF;
      }
    }
  }

  .divide {
    width: 1499px;
    height: 1px;
    background: #EAEAEA;
    margin-left: 210px;
    opacity: 0.2;
  }

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    .image {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .printbelle {
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    color: #E0E0E0;
    display: flex;
    margin-left: 210px;
    margin-top: 28px;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue